/* eslint-disable */
'use strict';

const Login = {
    init: function() {
        window.addEventListener('hashchange', ()=>{
            this.handleFormsVisibility(); 
            this.handleForgetPassBtnClick();
        });
        
    },


    handleFormsVisibility: ()=>{
        var forgot_password_container = document.querySelector('.forgot-pass-initial');
        var forgot_password_check_email = document.querySelector('.forgot-pass-check-email');
        var login_container = document.querySelector('.login-form');

        if (window.location.href == 'https://www.healthycell.com/account/login') {
            if (forgot_password_container) {
                forgot_password_container.style.display = 'none';
                login_container.style.display = 'block';
                forgot_password_check_email.style.display = 'none';
            }
        }

        if (window.location.href.indexOf('recover') != -1) {
            if (forgot_password_container) {
                forgot_password_container.style.display = 'block';
                login_container.style.display = 'none';
                forgot_password_check_email.style.display = 'none';
            }
        }

        if (window.location.href.indexOf('check-email') != -1) {
            if (forgot_password_container) {
                forgot_password_container.style.display = 'none';
                login_container.style.display = 'none';
                forgot_password_check_email.style.display = 'block';
            }
        }
    },
    handleForgetPassBtnClick: ()=>{
        let forgot_password_btn = document.getElementById('forgot-password');
        if (forgot_password_btn) {
            forgot_password_btn.addEventListener("click", function() {
                window.location.href = '{{ routes.account_login_url | append: "#recover" }}';
                window.location.reload();
        });
        }
    }
};

export default Login;
